import * as React from 'react';

// const video = require('file-loader!./quickstart.mp4');

// console.log(video);

export type Props = {};

function App(props: Props) {
  const {} = props;

  return <></>;
  // return <video src={video.default}></video>;
}

export default React.memo(App);
